import { API_CONFIG } from "@/shared/configs/apiConfig.js"
export default {
  url({ type, period, companyId }) {
    const id = companyId || 'rapidoo'
    const periodKeys = {
      year: { key: 'month', limit: 12 },
      week: { key: 'day', limit: 7 },
      month: { key: 'day', limit: 30 },
    }
    const pk = periodKeys[period]
    return `${API_CONFIG.BASE_URLS.PAYMENT}/stats/${id}/${pk.key}/${pk.limit}?group=${API_CONFIG.GROUP}&service=rapidoo&type=wallet&subType=${type}`
  },

  parse(raw = {}, payload = { type: '', period: '' }) {
    console.log("🚀 ~ raw:", raw)
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: { stats: null },
        currency: 'XOF',
      }
    }

    const dates = getDateRange(payload.period).map((e)=>e.replace(/0(\d-)/g,'$1'))
    
    console.log("🚀 ~ dates:", dates)
    const dataMap = Object.fromEntries(
      (raw.data || []).map(el => [el.periodId, el.amount]),
    )

    const stats = dates.map(date => dataMap[date] || 0)

    return {
      statusCode: 200,
      data: { stats },
      currency: 'XOF',
    }
  },
}

function getDateRange(type = 'week') {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth()

  const formatDate = date =>
    date
      .toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      .replace(/\//g, '-')

  if (type === 'week') {
    const dayOfWeek = today.getDay()
    const monday = new Date(today)
    monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7))
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(monday)
      d.setDate(monday.getDate() + i)
      return formatDate(d)
    })
  }

  if (type === 'month') {
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    return Array.from({ length: daysInMonth }, (_, i) =>
      formatDate(new Date(year, month, i + 1)),
    )
  }

  if (type === 'year') {
    return Array.from(
      { length: 12 },
      (_, i) => `${String(i + 1).padStart(2, '0')}-${year}`,
    )
  }

  throw new Error("Type inconnu. Utilise 'week', 'month' ou 'year'.")
}
